/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RouterCreationList } from '../../models/router-creation-list';
import { RouterCreationResponse } from '../../models/router-creation-response';

export interface PostNewList$Params {
      body?: RouterCreationList
}

export function postNewList(http: HttpClient, rootUrl: string, params?: PostNewList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RouterCreationResponse>>> {
  const rb = new RequestBuilder(rootUrl, postNewList.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RouterCreationResponse>>;
    })
  );
}

postNewList.PATH = '/routers/list';
